<template>
    <Nav-component v-if="!userStore.user.id"></Nav-component>
    <div :class="{ 'content-wrapper container-xxl p-0': !userStore.user.id }">
        <div :class="{ 'cf-container-fluid': !userStore.user.id }">
            <div v-if="loadash.includes([userStore.super_admin, userStore.author], userStore.user.role)" class="d-flex flex-row-reverse">
                <div class="button-create mb-75 right-0 bg-success rounded text-center p1-50" style="height:45px;width:120px;">
                    <router-link
                        :to="{ name: 'blog-create'}"
                        class="text-white"
                    >
                        Create a blog
                    </router-link>
                </div>
            </div>
            <content-with-sidebar class="blog-wrapper">
                <div class="row" v-if="blogList.length">
                    <div class="col-md-6 col-12" v-for="(blog,index) in blogList" :key="index">
                        <div class="card">
                            <a href="#">
                                <img class="card-img-top img-fluid" :src='blog.blobImage' alt="">
                            </a>
                            <div class="card-body">
                                <h4 class="card-title">
                                    <router-link
                                        :to="{ name: 'blog-category-content', params: { category: blog.category_slug, slug: blog.slug } }"
                                        class="blog-title-truncate text-body-heading"
                                    >
                                        {{ blog.blogtitle }}
                                    </router-link>
                                </h4>
                                <div class="d-flex">
                                    <div class="avatar mr-75">
                                        <div class="avatar-content avatar-xl" :class="getRandomBackgroundClass" height="38" width="38">
                                        <span class="avatar-content">{{blog.authorAbv}}</span></div>
                                    </div>
                                    <div class="author-info ml-75">
                                        <small class="text-muted me-25 mr-75">Written by</small>
                                        <small><a href="#" class="text-body mr-75">Creditfixrr</a></small>
                                        <span class="text-muted ms-50 me-25 mr-75">|</span>
                                        <small class="text-muted">{{ blog.published_at }}</small>
                                    </div>
                                </div>
                                <div class="my-1 py-25">
                                    <a href="#" v-for="(tag,index) in blog.tags" :key="index">
                                        <span class='badge rounded-pill me-50 mr-75 badge-light-primary' style="margin-bottom:4px;">{{ tag }}</span>
                                    </a>
                                </div>
                                <p class="card-text blog-content-truncate" v-html="blog.teaser"></p>
                                <hr>
                                <div class="d-flex justify-content-between align-items-center">
                                    <a href="#">
                                        <div class="d-flex align-items-center">
                                            <vue-feather type='message-square' size="14" class="font-medium-1 text-body mr-50" />
                                            <span class="text-body fw-bold ml-75">{{ blog.comments_count}}   Comments</span>
                                        </div>
                                    </a>
                                    <router-link
                                        :to="{ name: 'blog-category-content', params: { category: blog.category_slug, slug: blog.slug } }"
                                        class="fw-bold"
                                    >
                                        Read More
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <b-col cols="12">
                        <div class="my-2 d-flex justify-content-center">
                            <pagination v-model="currentPage" :records="rows" :per-page="perPage" @paginate="list"/>
                        </div>
                    </b-col>
                </div>
                <div class="row" v-else>
                    <div class="col-md-12 col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="media">
                                    <h5>No Posts</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <template
                    #sidebar
                    class="blog-sidebar py-2 py-lg-0"
                >
                    <div class="blog-search">
                        <div class="input-group input-group-merge relative">
                            <input type="text" class="form-control" placeholder="Search here" v-model="searchVal" @keyup="result"/>
                            <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                    <vue-feather size="14" type="search" />
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="blog-recent-posts mt-3" v-show="displayer">
                        <h6 class="section-label">Blog Results Posts</h6>
                        <div v-if="Object.keys(searchResult).length">
                            <div class="mt-75" v-for="(result,index) in searchResult" :key="index">
                                <div class="media mb-2">
                                    <a href="#" class="mr-2">
                                        <img class="rounded" :src="result.blobImage" width="100" height="70" :alt="result.blobImage.slice(6)" />
                                    </a>
                                    <div class="media-body">
                                        <h6 class="blog-recent-post-title">
                                            <a :href="'/blog/'+result.category_slug+'/'+result.slug" class="text-body-heading" style="font-size:12px" target="_self">{{ result.title }}</a>
                                        </h6>
                                        <div class="text-muted mb-0" style="font-size:11px">{{ result.published_at }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="card">
                                <div class="card-body">
                                    <div class="media">
                                        <h5>No Posts Result</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-3">
                        <h6 class="section-label mb-1">
                            Categories
                        </h6>
                        <div
                            v-for="category in category"
                            :key="category.icon"
                            
                        >
                            <router-link
                                :to="{ name: 'blogs', params: { category: category.category_slug } }"
                                class="d-flex justify-content-start align-items-center mb-75"
                            >
                                <b-avatar
                                    rounded
                                    size="32"
                                    variant="badge-light-primary"
                                    class="mr-75 badge-light-primary"
                                >
                                    <vue-feather type='droplet' icon />
                                </b-avatar>
                                <div class="blog-category-title text-body">
                                    {{ category.category }}
                                </div>
                            </router-link>
                        </div>
                    </div>
                </template>
            </content-with-sidebar>
        </div>
    </div>
</template>

<script>

import {BLink,BAvatar,BPagination} from 'bootstrap-vue-3'
import ContentWithSidebar from '../../@core/layouts/components/content-with-sidebar/ContentWithSidebar.vue'
import axios from 'axios'
import { useUserStore } from '../../stores/UserStore.js'
import { getRandomBackgroundClass } from '../../utilities/_helpers'
import NavComponent from './NavComponent.vue'

export default {
    name:'BlogComponent',
    components: {
        ContentWithSidebar,
        BLink,
        BAvatar,
        BPagination,
        NavComponent,
    },
    setup(props) {
        return {
            getRandomBackgroundClass: getRandomBackgroundClass,
            userStore: useUserStore(),
            loadash: _,
        }
    },
    data() {
        return {
            search_query: '',
            blogList: {},
            currentPage: 0,
            perPage: 0,
            prevPage:'',
            nextPage:'',
            rows: 0,
            category:{},
            searchVal:'',
            searchfeed:false,
            searchResult:{},
            baseUrl: baseUrl
        }
    },
    created() {
        this.list();
    },
    computed:{
        displayer(){
            return this.searchfeed?true:false;
        }
    },
  methods: {
    result(){
        let params = {
            searchvalue:this.searchVal
        }
        const $this = this;
        const route = this.$router.resolve(
            {
                name: 'blog-search',
            }
        );
        axios.get(route.href,{params}).then(({data})=>{
          if(!data.false && data.searchResult !=null){
              $this.searchResult = data.searchResult
              $this.searchfeed = true
          }else{
            $this.searchResult = {}
            $this.searchfeed = false
          }
        }).catch(({ response })=>{
            toastr.error(response.message, 'error!');
        })
    },
    async list(page){
        page = _.isNull(page) || _.isUndefined(page) ? 1 : page;
        const $this = this;
        const route = $this.$router.resolve(
            {
                name: 'blogs',
                params: {
                    category: this.$route.params.category
                },
                query: { page: page }
            }
        );
        await axios.get(route.href).then(({data})=>{
          if(!data.false){
            let dataCurrent = data.data;
            $this.blogList = dataCurrent.data
            $this.category = data.category
            $this.currentPage = dataCurrent.current_page
            $this.perPage = dataCurrent.per_page
            $this.prevPage = dataCurrent.prev_page_url
            $this.nextPage = dataCurrent.next_page_url
            $this.rows = dataCurrent.total
          }

        }).catch(({ response })=>{
            toastr.error(response.message, 'error!');
        })
    },
  },
}
</script>

<style lang="scss">
@import '../../../sass/vue/pages/page-blog.scss';
    .button-create {
        height:45px;
        width:120px;
        text-align: center;
        padding-top: 10px;
    }

    .VuePagination__count {
        display: none;
    }
    .icon {
        height:12px;
        width:12px;
    }
    .cf-container-fluid{
        width: 100%;
        padding-right: 30px;
        padding-left: 30px;
        padding-top:100px;
        margin-right: auto;
        margin-left: auto;
    }
</style>
